import downloadFile from '../../src/modules/shared/procedures/download-file';
import apiPaths from '../api-paths';

export default {
  submitBulk({ invoiceIds }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/ksef/invoices/submit-bulk`, {
      invoice_ids: invoiceIds,
    });
  },
  getAuditLog(invoiceId, query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef/invoices/${ invoiceId }/audit-log${ query }`);
  },
  downloadArtifact({ artifactType, invoiceOriginal }) {
    return downloadFile({
      action: axios.get(`${ apiPaths.BOOKKEEPING }/ksef/invoices/${ invoiceOriginal }/artifacts/${ artifactType }`, { responseType: 'blob' }),
      filename: `${ artifactType }-${ invoiceOriginal }.xml`,
    });
  },
  getUpoPdfUrl(invoiceOriginal) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef/invoices/${ invoiceOriginal }/upo-pdf`);
  },
};
